import templatesList from './modules/store'

export const modules = {
  templatesList
}



// WEBPACK FOOTER //
// ./src/store/Templates/index.js